module.exports = __webpack_public_path__ + "static/media/Rauf.f2899c7c.jpg";